import { Box } from '@mui/material'
import { useFrozenMovement } from './EditSettings.data'
import { useEffect, useState } from 'react'
import {
  EditSettingsTabViewProps,
  EditSettingsTableDataTypes,
} from './EditSettings.types'
import { Loader } from 'Common/Loader/Loader'
import { FrozenMovementMUITable } from './FrozenMovement.MUITable'

export const FrozenMovementTab = ({
  enabled,
  planId,
}: EditSettingsTabViewProps) => {
  const [frozenMovement, setFrozenMovement] = useState<
    [] | EditSettingsTableDataTypes[]
  >([])
  const { data: frozenMovementData, isLoading: isFrozenMovementDataLoading } =
    useFrozenMovement(planId, enabled)

  useEffect(() => {
    setFrozenMovement(frozenMovementData)
  }, [frozenMovementData])

  if (isFrozenMovementDataLoading) {
    return <Loader />
  }
  return (
    <Box padding={0} marginTop={2}>
      <Box>
        {frozenMovement && frozenMovement.length > 0 && (
          <FrozenMovementMUITable
            data={frozenMovement ?? []}
            isLoading={isFrozenMovementDataLoading}
          />
        )}
      </Box>
    </Box>
  )
}
